import { Building, Settings, SquareTerminal, User } from "lucide-react";
import Login from "../pages/auth/login/Login";
import Buildings from "../pages/dashboard/buildings/Buildings";
import BuildingDetail from "../pages/dashboard/buildings/BuilingDetail";
import AddBuilding from "../pages/dashboard/buildings/AddBuilding";
import Dashboard from "../pages/dashboard/Dashboard";
import Details from "../pages/dashboard/details/Details";
import Guards from "../pages/dashboard/guards/Guards";
import Home from "../pages/dashboard/home/Home";
import Management from "../pages/dashboard/management/Management";
import ManagementDetail from "../pages/dashboard/management/ManagementDetail";
import Profile from "../pages/dashboard/profile/Profile";
import Tenants from "../pages/dashboard/tenantsManagement/TenantsManagement";
import TenantDetail from "../pages/dashboard/tenantsManagement/TenantDetail";
import SuperAdmin from "../pages/dashboard/superAdmin/SuperAdmin";
import { roles } from "./constants";

export const routeNames = {
  login: "/auth/login",
  register: "/auth/register",
  dashboardHome: "/dashboard",
  details: "/dashboard/developer-details/:developerId",
  buildings: "/dashboard/buildings",
  buildingDetails: "/dashboard/building-details/:buildingId",
  addBuilding: "/dashboard/add-building",
  guards: "/dashboard/guards",
  profile: "/dashboard/profile",
  management: "/dashboard/management",
  managementDetail: "/dashboard/management-detail/:managementId",
  tenantsManagement: "/dashboard/tenants-management",
  tenantDetail: "/dashboard/tenant-detail/:tenantId",
  superAdmin: "/dashboard/super-admin",
};

export const authRoutes = [{ path: routeNames.login, component: Login }];

export const routes = [{ path: "/*", component: Dashboard }];

export const dashboardRoutes = [
  {
    path: routeNames.dashboardHome,
    component: Home,
    roles: [roles.superAdmin],
  },
  {
    path: routeNames.details,
    component: Details,
    roles: [roles.superAdmin],
  },
  {
    path: routeNames.superAdmin,
    component: SuperAdmin,
    roles: [roles.superAdmin],
  },
  {
    path: routeNames.buildings,
    component: Buildings,
    roles: [roles.propertyOwner],
  },
  {
    path: routeNames.addBuilding,
    component: AddBuilding,
    roles: [roles.propertyOwner],
  },
  {
    path: routeNames.buildingDetails,
    component: BuildingDetail,
    roles: [roles.propertyOwner],
  },
  {
    path: routeNames.guards,
    component: Guards,
    roles: [roles.propertyOwner],
  },
  {
    path: routeNames.management,
    component: Management,
    roles: [roles.propertyOwner],
  },
  {
    path: routeNames.managementDetail,
    component: ManagementDetail,
    roles: [roles.propertyOwner],
  },
  {
    path: routeNames.tenantsManagement,
    component: Tenants,
    roles: [roles.propertyOwner],
  },
  {
    path: routeNames.tenantDetail,
    component: TenantDetail,
    roles: [roles.propertyOwner],
  },
  {
    path: routeNames.profile,
    component: Profile,
    roles: [roles.propertyOwner],
  },
];
export const sideBarRoutes = [
  {
    title: "Developers",
    icon: User,
    isActive: true,
    url: routeNames.dashboardHome,
    roles: [roles.superAdmin],
  },
  {
    title: "Super Admins",
    icon: User,
    isActive: true,
    url: routeNames.superAdmin,
    roles: [roles.superAdmin],
  },
  {
    title: "Buildings",
    icon: Building,
    isActive: true,
    url: routeNames.buildings,
    roles: [roles.propertyOwner],
  },
];

export const getFilteredRoutes = (role: string) => {
  return dashboardRoutes.filter((route) => route.roles.includes(role));
};
